<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2021-11-15 11:41:13
 * @FilePath: \mrc-ess-fronted\src\components\MRC_ESS_Form_AutoComplete.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-08-05 10:11:00
-->
<template>
  <div class="flex-grow-1">
    <v-sheet
      v-if="showLabel"
      :class="
        isRequired && isFocus
          ? ' mrc_text_require primary--text '
          : isRequired
          ? ' mrc_text_require text--secondary '
          : ' text--secondary '
      "
      >{{ $t(label) }}</v-sheet
    >
    <v-autocomplete
      :key="curkey"
      v-model="curValue"
      :class="contentClass"
      :filled="forceFilled || (!readonly && !disabled && filled)"
      :items="items"
      :item-text="itemText"
      :item-value="itemValue"
      :readonly="readonly"
      :chips="chips || smallChips"
      :placeholder="placeholder"
      @error="isError = true"
      @blur="isFocus = false"
      @focus="isFocus = true"
      :disabled="disabled"
      :filter="filter"
      :allow-overflow="allowOverflow"
      :small-chips="smallChips"
      :height="height"
      :messages="messages"
      :hide-details="hideDetails"
      :dense="dense"
      :search-input="searchInput"
      :rounded="rounded"
      :rules="rules"
      :no-data-text="noDataText"
      @input="
        (val) => {
          $emit('input', val);
        }
      "
      :multiple="multiple"
      :append-icon="readonly || disabled ? '' : appendIcon"
      :single-line="singleLine"
      :menu-props="{
        offsetY: true,
        transition: 'slide-y-transition',
        rounded: true,
        contentClass: 'elevation-4',
      }"
      :deletable-chips="!readonly && !disabled && deletableChips"
    >
      <template v-slot:no-data>
        <noContent />
      </template>
      <template v-slot:prepend-item v-if="!forceNoCheck">
        <slot name="prepend-item" v-if="multiple && items.length > 1">
          <v-list-item
            dense
            class="px-4"
            @click="
              $nextTick(() => {
                if (curValue.length === items.length) {
                  curValue = [];
                } else {
                  curValue = [];
                  items.map((item) => {
                    curValue.push(item[itemValue]);
                  });
                }
              })
            "
          >
            <v-list-item-action class="mx-0 my-0 mr-1">
              <span
                class="material-icons-round"
                :class="
                  curValue.length !== 0 && curValue.length === items.length
                    ? 'primary--text'
                    : curValue.length > 0 && curValue.length !== items.length
                    ? 'primary--text'
                    : 'text--secondary'
                "
              >
                {{
                  curValue.length !== 0 && curValue.length === items.length
                    ? "check_box"
                    : curValue.length > 0 && curValue.length !== items.length
                    ? "indeterminate_check_box"
                    : "check_box_outline_blank"
                }}
              </span>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{
                  $t("label_essweb_system_select_selectAllLabel")
                }}</v-list-item-title
              >
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
        </slot>
      </template>
      <template v-slot:selection="data">
        <template v-if="customSelection">
          <slot name="item" :data="data" />
        </template>
        <template v-else>
          <template v-if="chips">
            <v-chip
              :close="!readonly && !disabled && deletableChips"
              :small="smallChips"
              :pill="avatar"
              :input-value="data.selected"
              v-if="data.index < $selectSetting.maxChips"
              @click="data.select"
              @click:close="multiple ? removeItem(data.item) : (curValue = '')"
            >
              <slot name="selection.avatar" :data="data"> </slot>
              <slot name="selection" :data="data">
                {{ $getCommonLangValue(data.item[itemText]) }}
              </slot>
            </v-chip>
            <span
              v-if="data.index === $selectSetting.maxChips"
              class="text--primary py-2"
            >
              ...{{ curValue.length - $selectSetting.maxChips }}
              <span v-if="!simple"
                >{{ $t("label_essweb_selection_moreItemLabel") }}
              </span></span
            >
          </template>
          <template v-else>
            <span>
              <slot name="selection" :data="data">
                {{ $getCommonLangValue(data.item[itemText]) }}
              </slot>
            </span>
          </template>
        </template>
      </template>
      <template v-slot:item="data">
        <slot v-if="customItem" name="item" :data="data" />
        <v-list-item
          v-else
          :dense="dense"
          :class="
            (
              multiple
                ? curValue.indexOf(data.item[itemValue]) != -1
                : curValue && String(curValue) === String(data.item[itemValue])
            )
              ? 'primary lighten-5'
              : 'transparent'
          "
          v-bind="data.attrs"
          v-on="data.on"
          class="px-4 transparent"
        >
          <v-list-item-action v-if="multiple && !forceNoCheck">
            <v-checkbox
              :value="curValue.indexOf(data.item[itemValue]) != -1"
              :input-value="curValue.indexOf(data.item[itemValue]) != -1"
              color="primary"
              :ripple="false"
              class="primary--text"
            ></v-checkbox>
          </v-list-item-action>
          <v-list-item-avatar v-if="avatar">
            <slot name="item.avatar" :data="data" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title class="text--primary">
              <slot name="item.title" :data="data">
                {{ $getCommonLangValue(data.item[itemText]) }}
              </slot></v-list-item-title
            >
            <v-list-item-subtitle v-if="twoLine" class="text--secondary">
              <slot name="item.subtitle" :data="data" />
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "AutoComplete",
  computed: {
    ...mapGetters(["isLoading"]),
    curkey: {
      get() {
        return this.mrcKey;
      },
      set(val) {
        return val;
      },
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  props: {
    items: {
      default: () => {
        return [];
      },
      type: [String, Array],
    },
    mrcKey: { default: "123", type: [String, Number, Array, Object] },
    customSelection: { default: false, type: [Boolean, Number] }, //不使用模版，自定义选中项
    customItem: { default: false, type: [Boolean, Number] }, //不使用模版，自定义下拉项
    itemText: { default: "", type: String },
    contentClass: { default: "", type: String },
    itemValue: { default: "", type: String },
    noDataText: { default: "", type: String },
    value: { default: "", type: [String, Number, Array, Object] },
    autofocus: { default: false, type: [Boolean, Number] },
    isRequired: { default: false, type: [Boolean, Number] },
    hideDetails: { default: false, type: [Boolean, Number] },
    rounded: { default: false, type: [Boolean, Number] },
    searchInput: { default: "", type: [Number, String] },
    smallChips: { default: false, type: [Boolean, Number] },
    simple: { default: false, type: [Boolean, Number] },
    allowOverflow: { default: false, type: [Boolean, Number] },
    forceNoCheck: { default: false, type: [Boolean, Number] }, //强制关闭checkbox
    filter: { type: Function },
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    twoLine: { default: false, type: [Boolean, Number] },
    avatar: { default: false, type: [Boolean, Number] },
    prefix: { default: "", type: [Number, String, Array, Object] },
    suffix: { default: "", type: [Number, String, Array, Object] },
    label: { default: "", type: [String, Function, Object] },
    messages: { default: "", type: [String, Function, Object] },
    placeholder: { default: "", type: [String, Function] },
    height: { default: "", type: [String, Number] },
    singleLine: { default: true, type: Boolean },
    forceFilled: { default: false, type: [Boolean, Number] }, //强制Filled模式，部分场景使用
    showLabel: { default: true, type: Boolean },
    hint: { default: "", type: String },
    filled: { default: true, type: Boolean },
    readonly: { default: false, type: Boolean },
    disabled: { default: false, type: Boolean },
    dense: { default: true, type: Boolean },
    chips: { default: false, type: Boolean },
    deletableChips: { default: false, type: Boolean },
    multiple: { default: false, type: Boolean },
    appendIcon: { default: "arrow_drop_down", type: [String] },
  },
  data() {
    return {
      curValue: [],
      isFocus: false,
      isError: false,
    };
  },
  created() {
    // 初始化//解决提交表单不验证问题
    this.curValue = " ";
    this.curkey = Math.random() * 1000000;
    this.curValue = "";
    if (this.value) this.curValue = this.value;
  },
  mounted() {},
  watch: {
    value(val) {
      this.curValue = val;
    },
    curValue(val) {
      this.$emit("change", val);
    },
  },
  methods: {
    removeItem: function (item) {
      const index = this.curValue.indexOf(item[this.itemValue]);
      if (index >= 0) this.curValue.splice(index, 1);
    },
  },
};
</script>